/**
 * Komprese obrázku v prohlížeči přes canvas.
 * Vrací File s redukovaným rozlišením a JPEG kvalitou.
 */

export async function compressImage(file, { maxWidth = 1920, quality = 0.85 } = {}) {
    if (!file || !file.type.startsWith('image/')) return file;

    // Pokud je už menší, neuploadujeme zbytečně přes canvas (zachováme metadata)
    if (file.size < 500 * 1024) return file;   // < 500 kB → necháme tak

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    try {
        await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = () => reject(new Error('Nelze načíst obrázek'));
            img.src = objectUrl;
        });

        const ratio = img.naturalWidth > maxWidth ? maxWidth / img.naturalWidth : 1;
        const w = Math.round(img.naturalWidth * ratio);
        const h = Math.round(img.naturalHeight * ratio);

        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        // Lepší downscale kvalita
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, w, h);

        const blob = await new Promise((res, rej) => {
            canvas.toBlob(b => b ? res(b) : rej(new Error('Komprese selhala')), 'image/jpeg', quality);
        });

        const newName = file.name.replace(/\.[^.]+$/, '') + '.jpg';
        return new File([blob], newName, { type: 'image/jpeg', lastModified: Date.now() });
    } finally {
        URL.revokeObjectURL(objectUrl);
    }
}
